
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/responsible-disclosure",
      function () {
        return require("private-next-pages/responsible-disclosure.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/responsible-disclosure"])
      });
    }
  